(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfp-global-footer"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const result=document.querySelector('#PfpFooterNewsletterResult[data-pf-newsletter-result]');
  if(!result)return;
  let active=true,frame,observer,timer,retry;
  const move=()=>{
    if(!active)return;
    const root=document.documentElement;
    const previous=root.style.scrollBehavior;
    root.style.scrollBehavior='auto';
    const rect=result.getBoundingClientRect();
    window.scrollTo(0,Math.max(0,window.scrollY+rect.top-(window.innerHeight-rect.height)/2));
    root.style.scrollBehavior=previous;
    result.focus({preventScroll:true});
  };
  const stop=()=>{
    active=false;
    cancelAnimationFrame(frame);
    clearTimeout(timer);
    clearInterval(retry);
    observer?.disconnect();
    ['pointerdown','touchstart','wheel','keydown'].forEach(type=>window.removeEventListener(type,stop));
  };
  const start=()=>{
    if(!active)return;
    move();
    observer=new ResizeObserver(()=>{
      cancelAnimationFrame(frame);
      frame=requestAnimationFrame(move);
    });
    const main=document.querySelector('#MainContent');
    if(main)observer.observe(main);
    observer.observe(result);
    retry=setInterval(move,150);
    timer=setTimeout(stop,5000);
  };
  ['pointerdown','touchstart','wheel','keydown'].forEach(type=>window.addEventListener(type,stop,{passive:true}));
  if(document.readyState==='complete')start();
  else window.addEventListener('load',start,{once:true});
})();

  } catch(e) { console.error(e); }
})();
})();
